module.exports = __webpack_public_path__ + "static/media/Zigram Website logo.201207e6.svg";